import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isChatEnabledForCurrentUser } from "../utils/chatAccess";

const ChatAccessRoute = ({ children }: { children: ReactNode }) =>
  isChatEnabledForCurrentUser() ? <>{children}</> : <Navigate to="/home" replace />;

export default ChatAccessRoute;
